import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { GeneralService } from '../../services/general.service';
import { Validators, FormBuilder } from '@angular/forms';
import { AbstractForm } from '../../utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { AppLoadingService } from '../../services/apploading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent extends AbstractForm implements OnInit, AfterViewInit {

  @Input() report : any;

  init = false;

  params:any={};

  feedbackSended = false;

  submitted = false;

  subjects = [
    { id: 'feedback', title: "Feedback" },
    { id: 'suggestion', title: "Sugestão" },
    { id: 'denounce', title: "Denúncia" },
    { id: 'problem', title: "Problema" }
  ];

  
  settingsData:any = {};

  protected settings: Subscription;

  constructor( 
    public gs : GeneralService,
    protected httpService: HttpService,
    protected formBuilder: FormBuilder,
    protected als: AppLoadingService,
    logger: LoggerService) {
      super(formBuilder, logger,false);

      this.settings = this.gs.settingsLoad$.subscribe(result => this.settingsData = result);

  }

  ngOnInit() {
    this.formDefault();
  }

  ngAfterViewInit(){
    this.init = true;
    this.formGroup.markAsPristine();
  }

  buildFormGroup(){
    let id = this.report?.modal?.subject || false;
    console.log(this.subjects);
    return this.formBuilder.group({
      type: [!id? this.subjects[0] : this.subjects.filter(item => item.id == id)[0], [Validators.required]],
      message: ['', [Validators.required]]
    });
  }

  updateControls() { }
  updateObject(): any { }

  sendHelpReport() {
    //API.general.help.report
    let values = this.getFormValues(this.formGroup);

    values.type = values.type.id;

    if(this.report?.modal?.message){
      values.message = this.report?.modal?.message + '  '+ values.message;
    }

    this.httpService.post<any>(API.general.help.report, values)
      .then(result => {
        this.formGroup.reset();
        this.feedbackSended = true;
      })
      .catch((err) => this.gs.error(err))
      .finally(() => {
        this.submitted = false;
        this.als.setLoaded(true, 'profile');
      });
  }

  onSupport(){
    var  element = document.createElement('a') as HTMLElement;
    element.setAttribute('href', 'https://wa.me/'+(this.settingsData?.supportPhone? this.settingsData?.supportPhone : '+5547991375257'));
    element.setAttribute('style', 'display:none;');
    element.setAttribute('target', '_blank');
    element.click();
  }

  compareFn(c1: any, c2: any): boolean {
    console.log(c1, c2);
    if(c2 === null)
      return false;

      return c1?.id == c2 || c1 == c2?.id || c1?.id == c2?.id;

  }

}